import { render, staticRenderFns } from "./CuponHeaderCard.vue?vue&type=template&id=31077c9d&scoped=true&"
import script from "./CuponHeaderCard.vue?vue&type=script&lang=js&"
export * from "./CuponHeaderCard.vue?vue&type=script&lang=js&"
import style0 from "./CuponHeaderCard.vue?vue&type=style&index=0&id=31077c9d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31077c9d",
  null
  
)

export default component.exports